module.exports = __webpack_public_path__ + "static/media/logo.3aaeb9f7.png";